import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getCoveShedAddressList(labelName,pageNum,pageSize) {
  return request({
    url: '/coveShed/getCoveShedAddressList',
    params: {
      labelName: labelName,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function updateCoveShedAddress(coveShedAddress) {
  return requestMsg({
    url: '/coveShed/updateCoveShedAddress',
    data: JSON.stringify(coveShedAddress),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function getCoveShedAddressById(id) {
  return requestMsg({
    url: '/coveShed/getCoveShedAddressById',
    params: {
      id: id,
    }
  })
}

export function delByCoveShedAddressId(id) {
  return requestMsg({
    url: '/coveShed/delByCoveShedAddressId',
    params: {
      id: id,
    }
  })
}
